<template>
    <div class="loading">
        <img src="/images/loading/loading-v1-100x100.gif" :style="imageWidth">
    </div>
</template>

<script>
    export default {
        props: {
            size: {
                type: String,
                default: '48px'
            },
        },

        computed:{
           imageWidth(){
               return 'width:' + this.size
           }
        },

        data(){
            return{
            }
        }

    }

</script>

<style scoped>

.loading{
    align-items: center;
    justify-content: center;
    display: flex;
    width: 100%;
    height: 100%;
}

</style>